import { createAsyncThunk } from "@reduxjs/toolkit";
import { CommonRootState } from "@common/types/common-root-state-type";
import { DBWaNoteThunks } from "./DBServiceThunks";
import { subscriptionPopupActions } from "./SubscriptionPopupReducer";
import { WaNote } from "@common-models/WaNote";
import { isDBServiceError } from "@common/utils/feathers-error-utils";

interface CreateNoteParams {
    note: WaNote;
}

// Create new note with CRM limit error handling
export const createWaNoteThunk = createAsyncThunk<
    WaNote,
    CreateNoteParams,
    { state: CommonRootState }
>(
    'waNotes/createWithLimitCheck',
    async ({ note }, thunkApi) => {
        const dispatch = thunkApi.dispatch;

        const result = await dispatch(DBWaNoteThunks.create(note)).unwrap();

        // Check if the result is an error object
        if (isDBServiceError(result)) {
            console.error('[wa-notes-thunks] Server validation error:', result);

            // Extract error message from the data property
            const errorMessage = result.data.message || String(result);

            // Check if error is due to CRM limit reached
            if (errorMessage.includes('total notes limit') || errorMessage.includes('reached your total notes limit')) {
                dispatch(subscriptionPopupActions.openPopup({
                    feature: 'notes',
                    message: errorMessage,
                    upgradeReason: 'total_notes_limit'
                }));
                throw new Error(errorMessage);
            } else if (errorMessage.includes('notes limit for this contact') || errorMessage.includes('per contact')) {
                dispatch(subscriptionPopupActions.openPopup({
                    feature: 'notes',
                    message: errorMessage,
                    upgradeReason: 'per_contact_notes_limit'
                }));
                throw new Error(errorMessage);
            } else {
                // Generic error - re-throw
                throw new Error(errorMessage);
            }
        }

        // Success - return the created note
        return result as WaNote;
    }
);
